import { ButtonProps, Button as ChakraButton } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';

export function Button({ children, backgroundColor ="primaryColor", ...props }: PropsWithChildren & ButtonProps) {
  return (
    <ChakraButton
      fontSize={'18px'}
      borderRadius={'100px'}
      fontFamily={'Glory'}
      fontWeight={600}
      minHeight={'56px'}
      backgroundColor={backgroundColor}
      color="white"
      width={'100%'}
      iconSpacing={5}
      _hover={{ backgroundColor: backgroundColor }}
      {...props}
    >
      {children}
    </ChakraButton>
  );
}
